import { Button } from '@neshane/blueberry';

import styles from './Footer.module.css';

export const FooterInitialCompany = ({ actions, allowOnBack, handleBack }) => {
    return (
        <div className="col-start-1 mt-64">
            <div
                className={`fixed bottom-0 left-0 w-full ${styles.footer}`}
            >
                <div className="m-auto flex max-w-[848px] items-center justify-between p-16">
                    {allowOnBack && (
                        <Button
                            variant="secondaryNeutral"
                            aria-label="back"
                            onClick={handleBack}
                            text="بازگشت"
                            iconName="chevron-right"
                        />
                    )}

                    <div className="mr-auto flex gap-24">{actions}</div>
                </div>
            </div>
        </div>
    );
};